export default __webpack_public_path__ + "static/media/card-1.fabbbdc6.svg";